import { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import logo from '../assets/logo.png';

// ── Nav link definitions ──────────────────────────────────────────────────────

const navLinks = {
  admin: [
    { label: 'Dashboard',  to: '/dashboard',         icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
    { label: 'Users',      to: '/users',              icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
    { label: 'Courses',    to: '/courses',            icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
    { label: 'Batches',    to: '/batches',            icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10' },
    { label: 'Classes',    to: '/classes',            icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
    { label: 'Recordings', to: '/trainer/recordings', icon: 'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664zM21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { label: 'Self-Paced', to: '/selfpaced',          icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
    { label: 'Feed',       to: '/feed',               icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    { label: 'Progress',   to: '/trainer/progress',   icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
    { label: 'Reports',    to: '/reports',            icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
    { label: 'Analytics',  to: '/analytics',          icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
    { label: 'CareerAI',   to: '/admin/careerai',     icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z' },
  ],
  trainer: [
    { label: 'Dashboard',   to: '/dashboard',          icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
    { label: 'My Classes',  to: '/classes',            icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
    { label: 'My Batches',  to: '/batches',            icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10' },
    { label: 'Materials',   to: '/trainer/materials',  icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
    { label: 'Recordings',  to: '/trainer/recordings', icon: 'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664zM21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { label: 'Feed',        to: '/feed',               icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    { label: 'Progress',    to: '/trainer/progress',   icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
    { label: 'Reports',     to: '/reports',            icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
    { label: 'Assignments', to: '/trainer/assignments',icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
  ],
  student: [
    { label: 'Dashboard',   to: '/dashboard',          icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
    { label: 'My Classes',  to: '/classes',            icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
    { label: 'Materials',   to: '/student/materials',  icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
    { label: 'Recordings',  to: '/student/recordings', icon: 'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664zM21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { label: 'Self-Paced',  to: '/student/selfpaced',  icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
    { label: 'Feed',        to: '/student/feed',       icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    { label: 'Assignments', to: '/student/assignments',icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
    { label: 'Progress',    to: '/student/progress',   icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
    { label: 'CareerAI',    to: '/student/careerai',   icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z', spark: true },
  ],
};

// ── Design tokens ─────────────────────────────────────────────────────────────
const SIDEBAR_BG = '#ebebeb';
const ACTIVE_BG  = '#20C997';
const DARK_BLUE  = '#003479';

// ── Notification helpers ───────────────────────────────────────────────────────

const TYPE_META = {
  assignment_posted:   { color: '#3b82f6', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
  feed_item:           { color: '#8b5cf6', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
  class_scheduled:     { color: '#10b981', icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
  assignment_graded:   { color: '#f59e0b', icon: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z' },
  class_starting_soon: { color: '#ef4444', icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' },
};

function timeAgo(dateStr) {
  const diff = (Date.now() - new Date(dateStr)) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

// ── Notification Dropdown ────────────────────────────────────────────────────

const NotificationDropdown = ({ notifications, onMarkRead, onMarkAll, onViewAll, onClose, style }) => {
  const hasUnread = notifications.some(n => !n.is_read);

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 9999,
        width: 340,
        background: '#fff',
        borderRadius: 14,
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        ...style,
      }}
    >
      {/* Header */}
      <div style={{ padding: '12px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: DARK_BLUE }}>Notifications</span>
        {hasUnread && (
          <button
            onClick={onMarkAll}
            style={{ fontSize: 12, color: '#20C997', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            Mark all as read
          </button>
        )}
      </div>

      {/* List */}
      <div style={{ maxHeight: 360, overflowY: 'auto' }}>
        {notifications.length === 0 ? (
          <div style={{ padding: '32px 16px', textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>
            No notifications yet
          </div>
        ) : (
          notifications.map(n => {
            const meta = TYPE_META[n.type] || { color: '#6b7280', icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' };
            return (
              <button
                key={n.id}
                onClick={() => onMarkRead(n.id, n.link)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 12,
                  padding: '12px 16px',
                  background: n.is_read ? 'transparent' : 'rgba(32,201,151,0.06)',
                  border: 'none',
                  borderBottom: '1px solid #f3f4f6',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.04)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = n.is_read ? 'transparent' : 'rgba(32,201,151,0.06)'; }}
              >
                <div style={{ width: 34, height: 34, borderRadius: 8, background: `${meta.color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <svg width={16} height={16} fill="none" stroke={meta.color} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={meta.icon} />
                  </svg>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <p style={{ fontSize: 13, fontWeight: n.is_read ? 500 : 700, color: '#111827', margin: 0, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {n.title}
                    </p>
                    {!n.is_read && <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#20C997', flexShrink: 0 }} />}
                  </div>
                  <p style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0', lineHeight: 1.4, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                    {n.message}
                  </p>
                  <p style={{ fontSize: 11, color: '#9ca3af', margin: '4px 0 0' }}>{timeAgo(n.created_at)}</p>
                </div>
              </button>
            );
          })
        )}
      </div>

      {/* Footer */}
      <div style={{ padding: '10px 16px', borderTop: '1px solid #f3f4f6' }}>
        <button
          onClick={onViewAll}
          style={{ width: '100%', textAlign: 'center', fontSize: 13, fontWeight: 600, color: DARK_BLUE, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 0' }}
        >
          View all notifications →
        </button>
      </div>
    </div>
  );
};

// ── Bell button ───────────────────────────────────────────────────────────────

const BellButton = ({ unreadCount, onClick, bellRef, style }) => (
  <button
    ref={bellRef}
    onClick={onClick}
    style={{ position: 'relative', background: 'none', border: 'none', cursor: 'pointer', padding: 6, borderRadius: 8, color: '#374151', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}
    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.06)'; }}
    onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
    title="Notifications"
  >
    <svg width={20} height={20} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
    {unreadCount > 0 && (
      <span style={{
        position: 'absolute', top: 2, right: 2,
        minWidth: 16, height: 16, borderRadius: 8,
        background: '#ef4444', color: '#fff',
        fontSize: 10, fontWeight: 700,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '0 3px',
        lineHeight: 1,
      }}>
        {unreadCount > 99 ? '99+' : unreadCount}
      </span>
    )}
  </button>
);

// ── Shared sidebar content ────────────────────────────────────────────────────

const SidebarContent = ({ user, role, links, location, onLinkClick, logout, bellSlot }) => {
  const isActive = (to) => location.pathname === to;
  const initial  = (user?.full_name || user?.email || '?').charAt(0).toUpperCase();

  return (
    <div className="flex flex-col h-full" style={{ background: SIDEBAR_BG }}>

      {/* ── Logo ───────────────────────────────────────────────────────── */}
      <div className="px-5 pt-6 pb-5 flex-shrink-0" style={{ borderBottom: '1px solid #d6d6d6' }}>
        <div className="flex items-center gap-3">
          <Link to="/dashboard" onClick={onLinkClick} className="flex items-center gap-3 flex-1 min-w-0">
            <img src={logo} alt="AI Mentorship Hub" className="h-9 w-auto object-contain flex-shrink-0" />
            <div className="leading-tight min-w-0">
              <p className="font-bold text-sm" style={{ color: DARK_BLUE }}>Learning</p>
              <p className="font-bold text-sm" style={{ color: DARK_BLUE }}>Platform</p>
            </div>
          </Link>
          {bellSlot}
        </div>
      </div>

      {/* ── Role badge ─────────────────────────────────────────────────── */}
      <div className="px-5 py-3 flex-shrink-0">
        <span
          className="text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full"
          style={{ background: 'rgba(0,52,121,0.08)', color: DARK_BLUE }}
        >
          {role === 'admin' ? 'Administrator' : role === 'trainer' ? 'Trainer' : 'Student'}
        </span>
      </div>

      {/* ── Nav links ──────────────────────────────────────────────────── */}
      <nav className="flex-1 px-3 py-2 space-y-0.5 overflow-y-auto">
        {links.map((link) => {
          const active = isActive(link.to);
          return (
            <Link
              key={link.to}
              to={link.to}
              onClick={onLinkClick}
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-150"
              style={active ? { background: ACTIVE_BG, color: '#fff' } : { color: '#374151' }}
              onMouseEnter={e => {
                if (!active) { e.currentTarget.style.background = 'rgba(0,0,0,0.06)'; e.currentTarget.style.color = DARK_BLUE; }
              }}
              onMouseLeave={e => {
                if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#374151'; }
              }}
            >
              <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={active ? 2.5 : 2} d={link.icon} />
              </svg>
              <span>{link.label}</span>
              {active ? (
                <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white/80" />
              ) : link.spark ? (
                <span className="ml-auto relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-60" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-primary" />
                </span>
              ) : null}
            </Link>
          );
        })}
      </nav>

      {/* ── User info + logout ─────────────────────────────────────────── */}
      <div className="px-3 pb-4 pt-3 flex-shrink-0" style={{ borderTop: '1px solid #d6d6d6' }}>
        <div className="flex items-center gap-3 px-3 py-2 mb-1 rounded-xl" style={{ background: 'rgba(0,0,0,0.04)' }}>
          <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm text-white" style={{ background: DARK_BLUE }}>
            {initial}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold truncate" style={{ color: '#111827' }}>{user?.full_name || 'User'}</p>
            <p className="text-xs truncate" style={{ color: '#9ca3af' }}>{user?.email}</p>
          </div>
        </div>
        <button
          onClick={logout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-150 mt-1"
          style={{ color: '#6b7280' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(239,68,68,0.08)'; e.currentTarget.style.color = '#dc2626'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#6b7280'; }}
        >
          <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Sign Out
        </button>
      </div>
    </div>
  );
};

// ── Main Navbar (Sidebar) Component ──────────────────────────────────────────

const Navbar = () => {
  const { user, logout, role } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  // Bell state (students only)
  const [unreadCount, setUnreadCount]       = useState(0);
  const [notifications, setNotifications]   = useState([]);
  const [showDropdown, setShowDropdown]     = useState(false);
  const [dropdownStyle, setDropdownStyle]   = useState({});
  const desktopBellRef = useRef(null);
  const mobileBellRef  = useRef(null);
  const dropdownRef    = useRef(null);
  const isStudent = role === 'student';

  const links = navLinks[role] || navLinks.student;
  const sharedProps = { user, role, links, location, logout };

  // ── Fetch unread count ─────────────────────────────────────────────────────
  const fetchUnreadCount = useCallback(async () => {
    if (!isStudent) return;
    try {
      const res = await api.get('/api/notifications/unread-count');
      setUnreadCount(res.data.unread_count);
    } catch {}
  }, [isStudent]);

  useEffect(() => {
    if (!isStudent) return;
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 60000);
    return () => clearInterval(interval);
  }, [isStudent, fetchUnreadCount]);

  // ── Close dropdown on outside click ──────────────────────────────────────
  useEffect(() => {
    if (!showDropdown) return;
    const handle = (e) => {
      if (
        dropdownRef.current && !dropdownRef.current.contains(e.target) &&
        !desktopBellRef.current?.contains(e.target) &&
        !mobileBellRef.current?.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [showDropdown]);

  // ── Open dropdown ─────────────────────────────────────────────────────────
  const openDropdown = async (ref) => {
    if (showDropdown) { setShowDropdown(false); return; }
    const rect = ref.current.getBoundingClientRect();
    // Position: below the bell, aligned left if enough space, otherwise right-anchored
    const dropW = 340;
    let left = rect.left;
    if (left + dropW > window.innerWidth - 8) left = window.innerWidth - dropW - 8;
    setDropdownStyle({ top: rect.bottom + 6, left: Math.max(8, left) });
    try {
      const res = await api.get('/api/notifications?limit=10');
      setNotifications(res.data);
    } catch {}
    setShowDropdown(true);
  };

  // ── Mark read ─────────────────────────────────────────────────────────────
  const handleMarkRead = async (id, link) => {
    try {
      await api.patch(`/api/notifications/${id}/read`);
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch {}
    setShowDropdown(false);
    if (link) navigate(link);
  };

  const handleMarkAll = async () => {
    try {
      await api.patch('/api/notifications/read-all');
      setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
      setUnreadCount(0);
    } catch {}
  };

  const handleViewAll = () => {
    setShowDropdown(false);
    navigate('/student/notifications');
  };

  // ── Bell slots ────────────────────────────────────────────────────────────
  const desktopBell = isStudent ? (
    <BellButton
      unreadCount={unreadCount}
      bellRef={desktopBellRef}
      onClick={() => openDropdown(desktopBellRef)}
    />
  ) : null;

  return (
    <>
      {/* ── Desktop sidebar (fixed) ─────────────────────────────────────── */}
      <div className="hidden lg:flex flex-col fixed inset-y-0 left-0 w-60 z-40" style={{ borderRight: '1px solid #d6d6d6' }}>
        <SidebarContent {...sharedProps} onLinkClick={undefined} bellSlot={desktopBell} />
      </div>

      {/* ── Mobile: top bar ─────────────────────────────────────────────── */}
      <div
        className="lg:hidden fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-4 h-14"
        style={{ background: SIDEBAR_BG, borderBottom: '1px solid #d6d6d6' }}
      >
        <Link to="/dashboard" className="flex items-center gap-2.5">
          <img src={logo} alt="AI Mentorship Hub" className="h-8 w-auto object-contain" />
          <div className="leading-tight">
            <p className="font-bold text-sm" style={{ color: DARK_BLUE }}>Learning</p>
            <p className="font-bold text-sm" style={{ color: DARK_BLUE }}>Platform</p>
          </div>
        </Link>
        <div className="flex items-center gap-1">
          {isStudent && (
            <BellButton
              unreadCount={unreadCount}
              bellRef={mobileBellRef}
              onClick={() => openDropdown(mobileBellRef)}
            />
          )}
          <button
            onClick={() => setMobileOpen(true)}
            className="p-2 rounded-lg transition-colors"
            style={{ color: '#374151' }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.06)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* ── Mobile sidebar overlay ──────────────────────────────────────── */}
      {mobileOpen && (
        <>
          <div className="lg:hidden fixed inset-0 bg-black/40 z-50 animate-fade-in" onClick={() => setMobileOpen(false)} />
          <div className="lg:hidden fixed inset-y-0 left-0 w-64 z-50 animate-fade-in" style={{ borderRight: '1px solid #d6d6d6' }}>
            <div className="relative h-full">
              <button
                onClick={() => setMobileOpen(false)}
                className="absolute top-5 right-4 p-1 rounded-lg z-10 transition-colors"
                style={{ color: '#6b7280' }}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <SidebarContent {...sharedProps} onLinkClick={() => setMobileOpen(false)} bellSlot={null} />
            </div>
          </div>
        </>
      )}

      {/* ── Notification dropdown (portal-style fixed) ──────────────────── */}
      {showDropdown && (
        <div ref={dropdownRef}>
          <NotificationDropdown
            notifications={notifications}
            onMarkRead={handleMarkRead}
            onMarkAll={handleMarkAll}
            onViewAll={handleViewAll}
            onClose={() => setShowDropdown(false)}
            style={dropdownStyle}
          />
        </div>
      )}
    </>
  );
};

export default Navbar;
